import styled from 'styled-components';
import React from 'react';
import { IEntityNode } from '../../Builder/EntitySelection/types';
import { DND_BASE_LAYER_Z_INDEX } from '../../DndEntity/constants';
import { theme } from '../../../styles/theme';
import DictionaryStyledDragItem from '../DictionaryStyledDragItem';

interface IProps {
  node: IEntityNode;
}

const Container = styled.div`
  position: absolute;
  z-index: ${DND_BASE_LAYER_Z_INDEX + 6};
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  width: 280px;
  border: 1px solid ${theme.colors.border};
  opacity: 0.8;
`;

const DictionaryEntityOverlay = ({ node }: IProps) => {
  return (
    <Container>
      <DictionaryStyledDragItem node={node} isActive={true}>
        {node.name}
      </DictionaryStyledDragItem>
    </Container>
  );
};

export default DictionaryEntityOverlay;
